import React from 'react';
import { HeaderIcon, IconCart } from '@banhala/ui-kit';
import { bridge, useNavigator } from 'shared/src/utils';
import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from 'shared/src/constant';
import { cartService } from '../api';

interface CartIconProps {
  screen: string;
  backgroundColor?: 'white' | 'transparent';
}

interface CartIconInternalProps {
  onPress: () => void;
  backgroundColor: 'white' | 'transparent';
}

export const CartIcon: React.FC<CartIconProps> = ({
  screen,
  backgroundColor,
}) => {
  const { navigator } = useNavigator();
  return (
    <React.Suspense
      fallback={
        <HeaderIcon
          testID={'장바구니버튼'}
          onPress={() => {
            handlePressIconCart(screen, navigator);
          }}
        >
          <IconCart />
        </HeaderIcon>
      }
    >
      <CartIconInternal
        backgroundColor={backgroundColor ?? 'white'}
        onPress={() => {
          handlePressIconCart(screen, navigator);
        }}
      />
    </React.Suspense>
  );
};

const logClickCart = (screen: string) => {
  bridge.logAnalyticsEvent({
    channel: ['firebase', 'facebook', 'amplitude', 'ablylog'],
    name: 'CLICK_CART',
    analytics: {
      SCREEN: screen,
      LANDING_FROM: 'CARTICON',
    },
  });
};

const handlePressIconCart = (
  screen: string,
  navigator: ReturnType<typeof useNavigator>['navigator'],
) => {
  logClickCart(screen);
  navigator.moveToWebview('Cart');
};

const CartIconInternal = ({
  onPress,
  backgroundColor,
}: CartIconInternalProps) => {
  const { data: cartsCount } = useSuspenseQuery({
    queryKey: queryKey.cartMeta,
    queryFn: cartService.getCartMeta,
    select: data => data.carts_count,
  });
  return (
    <HeaderIcon
      onPress={onPress}
      badgeNum={cartsCount > 0 ? cartsCount : undefined}
      testID={'장바구니버튼'}
      backgroundColor={backgroundColor}
    >
      <IconCart />
    </HeaderIcon>
  );
};
